/* eslint-disable @next/next/no-img-element */
import { ThumborDefaults, thumborLink, ThumborOptions } from './thumbor'
import { CSSProperties } from 'react'

interface Props {
	src: string
	alt: string
	options: ThumborOptions
	style?: CSSProperties
	className?: string
}

export const ThumborImg = ({ src, alt, options, style, className }: Props) => {
	if (src.endsWith('.svg')) return <img src={src} alt={alt} style={style} className={className} />

	const webpLink = thumborLink(src, { ...ThumborDefaults, ...options, filters: { format: 'webp' } })
	const jpegLink = thumborLink(src, { ...ThumborDefaults, ...options, filters: { format: 'jpeg' } })

	return (
		<picture>
			<source type="image/webp" srcSet={webpLink} />
			<source type="image/jpeg" srcSet={jpegLink} />
			<img src={jpegLink} alt={alt} style={{ maxWidth: '100%', maxHeight: '100%', ...style }} className={className} />
		</picture>
	)
}
